import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC7BdBElCOsUNYiqYDBK4w8kjlzKJVkcXQ",
  authDomain: "rajnety-web.firebaseapp.com",
  projectId: "rajnety-web",
  storageBucket: "rajnety-web.appspot.com",
  messagingSenderId: "519823812245",
  appId: "1:519823812245:web:728be6cadf6fe5b6c5dd9c",
  measurementId: "G-MWYY1FB4GF",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
